<dx-drop-down-box #ddBox [(value)]="gridBoxValue" [deferRendering]="false" [dataSource]="dataSource"
    [displayExpr]="boxDisplayExpr" [placeholder]="placeholder" [showClearButton]="showClearButton"
    [disabled]="disabled" (onValueChanged)="onBoxValueChanged($event)">
    <dx-validator *ngIf="requiredMessage">
        <dxi-validation-rule type="required" [message]="requiredMessage"></dxi-validation-rule>
    </dx-validator>
    <!-- Griglia interna alla dropbox: selezione singola + filtro per colonna -->
    <div *dxTemplate="let data of 'content'">
        <dx-data-grid #ddGrid [dataSource]="dataSource" [columns]="gridColumns" [selection]="selection"
            [filterRow]="filterRow" [scrolling]="scrolling" [height]="gridHeight" [noDataText]="noDataText"
            [hoverStateEnabled]="true" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
            [columnAutoWidth]="true" [(selectedRowKeys)]="gridBoxValue"
            (onSelectionChanged)="onGridSelectionChanged($event)">
            <div *dxTemplate="let cell of 'iconCellTemplate'">
                <img *ngIf="cell.data[cell.column.icon.field]" [src]="cell.column.icon.src"
                    class="grid-select-box-icon" />{{ cell.text }}
            </div>
        </dx-data-grid>
    </div>
</dx-drop-down-box>
